import { MptSelectorCard } from "./MptSelectorCard.js"

export const MptsSelectorCategories = props => {
  const lenght = props.data.length
  const dataArr = [...props.data]

  const firstPart = []
  const secondPart = []

  if (lenght > 4) {
    dataArr.forEach((item, index) => {
      if (index < 5) firstPart.push(item)
    })

    dataArr.forEach((item, index) => {
      if (index > 4) secondPart.push(item)
    })
  }
  else {
    dataArr.forEach(item => {
      firstPart.push(item)
    })
  }

  const containerClassName = props.containerVisible ? "linkContainer categorieVisible noContextMenu" : "linkContainer categorieHidden"

  return (
    <div className={containerClassName}>
      <div className="linkRow">
        {firstPart.map((item, index) => {
          return (
            <MptSelectorCard imgSrc={item.imgSrc} model={item.model} version={item.version} path={item.path} acceskey={item.acceskey} key={index} />
          )
        })}
      </div>

      <div className="lastLinkRow">
        {secondPart.map((item, index) => {
          return (
            <MptSelectorCard imgSrc={item.imgSrc} model={item.model} version={item.version} path={item.path} acceskey={item.acceskey} key={index} />
          )
        })}
      </div>
    </div>
  )
}